'use client';

import { InstagramIcon } from 'assets/icons/instagram-icon';

const linkClassName =
  'header-social-icon flex items-center text-secondary hover:opacity-70 transition-opacity';

export function InstagramLink() {
  return (
    <a
      aria-label="Instagram"
      className={linkClassName}
      href="https://www.instagram.com"
      rel="noopener noreferrer"
      target="_blank"
    >
      <InstagramIcon height={32} width={32} />
    </a>
  );
}
